
export const suggestionTypeOptions = [
  {
    value: 'topic',
    label: 'gpt-icebreaking-message-generation-topic'
  },
  {
    value: 'news',
    label: 'gpt-icebreaking-message-generation-news'
  }
];

export const creativityOptions = [
  {
    key: 'accurate',
    value: 'accurate',
    label: 'chat-gpt-ice-breaking-action-accurate'
  },
  {
    key: 'balanced',
    value: 'balanced',
    label: 'chat-gpt-ice-breaking-action-balanced'
  }
];
